import { TableCell } from '@mui/material';
import { Avatar } from '@shared/ui/parts';

export function TeamAvatar({ team }) {
  return (
    <div className="teamCell__avatar">
      <Avatar team={team} />
    </div>
  );
}

export function TeamName({ team }) {
  return (
    <div>
      <p>{team.name}</p>
      <p className="secondary-text">{team.teamLead?.name}</p>
    </div>
  );
}

export default function TeamCell({ row }) {
  return (
    <TableCell>
      <div className="teamCell">
        <TeamAvatar team={row} />
        <TeamName team={row} />
      </div>
    </TableCell>
  );
}
